import { render, staticRenderFns } from "./ProductsItemView.vue?vue&type=template&id=0a2474ca&scoped=true&"
import script from "./ProductsItemView.vue?vue&type=script&lang=js&"
export * from "./ProductsItemView.vue?vue&type=script&lang=js&"
import style0 from "./ProductsItemView.vue?vue&type=style&index=0&id=0a2474ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2474ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VSpacer})
